import React from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Typewriter from "typewriter-effect";
import { introdata, meta } from "../../content_option";
import { Link } from "react-router-dom";

const typewriterOptions = {
  strings: [
    introdata.animated.first,
    introdata.animated.second,
    introdata.animated.third,
  ],
  autoStart: true,
  loop: true,
  deleteSpeed: 10,
};

export const Home = () => {
  return (
    <HelmetProvider>
      <section id="home" className="home">
        <Helmet>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <title>{meta.title}</title>
          <meta name="description" content={meta.description} />
          <meta property="og:title" content={meta.title} />
          <meta property="og:description" content={meta.description} />
        </Helmet>

        <div className="intro_sec d-flex align-items-center justify-content-center">
          <div className="text text-center">
            <div className="intro mx-auto px-3">
              <h2 className="mb-3">{introdata.title}</h2>
              <h1 className="fluidz-48 mb-3">
                <Typewriter options={typewriterOptions} />
              </h1>
              <p className="mb-4">{introdata.description}</p>

              <div className="intro_btn-action d-flex flex-wrap justify-content-center gap-3">
                <Link to="/portfolio" className="ac_btn btn text_2" aria-label="Go to Projects">
                  My_Projects
                  <div className="ring one"></div>
                  <div className="ring two"></div>
                  <div className="ring three"></div>
                </Link>

                <Link to="/about" className="ac_btn btn" aria-label="Go to About">
                  About_Me
                  <div className="ring one"></div>
                  <div className="ring two"></div>
                  <div className="ring three"></div>
                </Link>

                <Link to="/blogs" className="ac_btn btn" aria-label="Go to Blogs">
                  Blogs
                  <div className="ring one"></div>
                  <div className="ring two"></div>
                  <div className="ring three"></div>
                </Link>

                <Link to="/contact" className="ac_btn btn" aria-label="Go to Contact">
                  Contact_Me
                  <div className="ring one"></div>
                  <div className="ring two"></div>
                  <div className="ring three"></div>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
}; 